import React from "react";

import ChevronLeft from "@material-ui/icons/ChevronLeft";

import {
  Edit,
  TextInput,
  SimpleForm,
  required,
  TopToolbar,
  ListButton,
  ShowButton,
  useNotify,
  useRefresh,
} from "react-admin";

const CatalogSampleActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} label="Back" icon={<ChevronLeft />} />
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);

const CatalogSamplesEdit = (props) => {
  const today = new Date();

  const notify = useNotify();
  const refresh = useRefresh();
  // const redirect = useRedirect();

  const onSuccess = () => {
    notify(`Changes saved`);
    // redirect("/posts");
    refresh();
  };
  return (
    <Edit
      title="Edit CatalogSample"
      undoable={false}
      onSuccess={onSuccess}
      submitOnEnter={true}
      actions={<CatalogSampleActions />}
      {...props}
    >
      <SimpleForm defaultValue={{ updated_at: today }}>
        <TextInput
          label="Code"
          source="code"
          validate={required("Code is required")}
        />
        <TextInput
          multiline
          label="Short Description"
          source="short_description"
        />
      </SimpleForm>
    </Edit>
  );
};

export default CatalogSamplesEdit;
